<main class="h-full font-sans">
  <!-- Header -->
  <header class="flex items-center justify-between mb-7">
    <div>
      <h1 class="text-2xl font-bold tracking-tight leading-tight text-primary-800 dark:text-primary-400">API Keys</h1>
      <p class="text-slate-500 dark:text-slate-400 text-xs mt-1">Credentials for external service integrations</p>
    </div>

    <div class="flex items-center gap-2">
    <button (click)="loadApiKeys()"
      class="px-3 py-1.5 rounded-lg text-slate-600 dark:text-slate-400 hover:text-slate-800 dark:text-slate-100 bg-white dark:bg-slate-800 hover:bg-slate-50 dark:hover:bg-slate-700 dark:bg-slate-800/60 border border-slate-200 dark:border-slate-700 transition-colors flex items-center gap-1.5 text-xs font-semibold" title="Refresh">
      <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
      </svg>

      <span>Refresh</span>
    </button>
    <div class="flex items-center border border-slate-200 dark:border-slate-700 rounded-lg overflow-hidden">
      <button type="button" (click)="viewMode = 'table'" [class]="viewMode === 'table' ? 'p-1.5 bg-primary-800 text-white' : 'p-1.5 bg-white dark:bg-slate-800 text-slate-400 hover:text-slate-600 dark:text-slate-400'" title="Table view">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 10h16M4 14h16M4 18h16"/></svg>
      </button>
      <button type="button" (click)="viewMode = 'grid'" [class]="viewMode === 'grid' ? 'p-1.5 bg-primary-800 text-white' : 'p-1.5 bg-white dark:bg-slate-800 text-slate-400 hover:text-slate-600 dark:text-slate-400'" title="Grid view">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 5a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1H5a1 1 0 01-1-1V5zm10 0a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1V5zM4 15a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1H5a1 1 0 01-1-1v-4zm10 0a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1v-4z"/></svg>
      </button>
    </div>
    @if (permissionService.canManage('apiKeys')) {
    <button (click)="addApiKeyClicked()"
      class="flex items-center gap-2 px-3 py-1.5 bg-white dark:bg-slate-800 hover:bg-slate-50 dark:hover:bg-slate-700 dark:bg-slate-800/60 text-slate-600 dark:text-slate-400 hover:text-slate-800 dark:text-slate-100 border border-slate-200 dark:border-slate-700 rounded-lg text-xs font-semibold transition-colors">
      <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M12 4v16m8-8H4" />
      </svg>
      Generate New Key
    </button>
    }
    </div>
  </header>

  <!-- Filter Section: Utilitarian -->
  <div class="mb-6 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl p-3">
    <form [formGroup]="searchQuery">
      <div class="relative max-w-sm">
        <input type="text" formControlName="keyword" placeholder="Filter by institution or key..."
          class="w-full h-10 px-3 bg-slate-50 dark:bg-slate-800/60 border border-gray-300 dark:border-slate-600 rounded-lg text-xs focus:outline-none focus:ring-2 focus:ring-primary-800/20 focus:border-primary-800 transition-all" />
      </div>
    </form>
  </div>

  <!-- Data Section -->
  @if (viewMode === 'table') {
  <div class="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl shadow-sm overflow-x-auto">
    <div class="min-w-[700px]">
      <div class="grid grid-cols-12 gap-x-4 bg-slate-50 dark:bg-slate-800/60 border-b border-slate-200 dark:border-slate-700 px-6 py-3">
        <div class="col-span-2"><p class="text-xs font-semibold text-slate-400">Institution</p></div>
        <div class="col-span-2"><p class="text-xs font-semibold text-slate-400">Public Key</p></div>
        <div class="col-span-3"><p class="text-xs font-semibold text-slate-400">Secret Key</p></div>
        <div class="col-span-2"><p class="text-xs font-semibold text-slate-400">Access</p></div>
        <div class="col-span-1 text-left"><p class="text-xs font-semibold text-slate-400">Status</p></div>
        <div class="col-span-2 text-left"><p class="text-xs font-semibold text-slate-400">Added On</p></div>
      </div>
      @if (isLoading()) {
      <div class="flex items-center justify-center py-16"><app-progress-loader></app-progress-loader></div>
      } @else if (hasApiKeys()) {
      @for (apiKey of apiKeys(); track apiKey.id) {
      <div class="grid grid-cols-12 gap-x-4 px-6 py-4 border-b border-slate-100 dark:border-slate-700/50 hover:bg-slate-50 dark:hover:bg-slate-700 dark:bg-slate-800/60 items-center transition-colors">
        <div class="col-span-2 min-w-0">
          <p class="text-xs font-bold text-slate-900 dark:text-white truncate">{{ apiKey.institution.name || '—' }}</p>
          <p class="text-[10px] text-slate-400 font-bold uppercase tracking-widest mt-0.5">{{ apiKey.institution.code || 'NO-CODE' }}</p>
        </div>
        <div class="col-span-3">
          <div class="flex items-center gap-1.5">
            <code class="text-[10px] text-slate-500 dark:text-slate-400 font-mono bg-slate-50 dark:bg-slate-800/60 px-1.5 py-0.5 rounded border border-slate-100 dark:border-slate-700/50 truncate max-w-[110px]">{{ apiKey.publicKey }}</code>
            <button (click)="copyToClipboard(apiKey.publicKey, 'public')" class="p-1 text-slate-400 hover:text-primary-800 dark:text-primary-400 transition-colors flex-shrink-0" title="Copy public key">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><rect width="14" height="14" x="8" y="8" rx="2" ry="2"/><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"/></svg>
            </button>
          </div>
        </div>
        <div class="col-span-3">
          <div class="flex items-center gap-1.5">
            <code class="text-[10px] text-slate-500 dark:text-slate-400 font-mono bg-slate-50 dark:bg-slate-800/60 px-1.5 py-0.5 rounded border border-slate-100 dark:border-slate-700/50 truncate max-w-[110px]">{{ isSecretRevealed(apiKey.id) ? apiKey.secretKey : maskSecret(apiKey.secretKey) }}</code>
            <button (click)="toggleSecretReveal(apiKey.id)" class="p-1 text-slate-400 hover:text-primary-800 dark:text-primary-400 transition-colors flex-shrink-0" [title]="isSecretRevealed(apiKey.id) ? 'Hide secret key' : 'Show secret key'">
              <img [src]="isSecretRevealed(apiKey.id) ? _images.visible : _images.unvisible" alt="" class="w-3 h-3 opacity-60 hover:opacity-90 dark:invert transition-opacity">
            </button>
            <button (click)="copyToClipboard(apiKey.secretKey, 'secret')" class="p-1 text-slate-400 hover:text-primary-800 dark:text-primary-400 transition-colors flex-shrink-0" title="Copy secret key">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><rect width="14" height="14" x="8" y="8" rx="2" ry="2"/><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"/></svg>
            </button>
          </div>
        </div>
        <div class="col-span-2">
          <div class="flex items-center gap-1.5 min-w-0">
            <span
              [title]="accessTooltip(apiKey)"
              [class]="apiKey.allowedOrigins?.length
                ? 'inline-block px-2 py-0.5 rounded-md text-[10px] font-semibold bg-amber-50 dark:bg-amber-950/40 text-amber-700 dark:text-amber-400 border border-amber-100 dark:border-amber-900 truncate'
                : 'inline-block px-2 py-0.5 rounded-md text-[10px] font-semibold bg-slate-100 dark:bg-slate-700/50 text-slate-500 dark:text-slate-400 border border-slate-200 dark:border-slate-700 truncate'">
              {{ accessSummary(apiKey) }}
            </span>
            @if (permissionService.canManage('apiKeys')) {
            <button (click)="openEditOrigins(apiKey)" class="p-1 text-slate-400 hover:text-primary-800 dark:text-primary-400 transition-colors flex-shrink-0" title="Edit allowed origins">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z"/></svg>
            </button>
            }
          </div>
        </div>
        <div class="col-span-1 flex justify-start">
          <span class="px-2 py-0.5 rounded-md text-[9px] font-bold border uppercase tracking-widest bg-emerald-50 dark:bg-emerald-950/40 text-emerald-600 dark:text-emerald-400 border-emerald-100 dark:border-emerald-900">Active</span>
        </div>
        <div class="col-span-2 text-left">
          <p class="text-sm font-bold text-slate-900 dark:text-white leading-tight">{{ apiKey.createdAt | date:'dd MMM' }}</p>
          <p class="text-xs text-slate-400 uppercase font-medium mt-0.5">{{ apiKey.createdAt | date:'yyyy' }}</p>
        </div>
      </div>
      }
      } @else {
      <div class="flex flex-col items-center justify-center py-20 text-center">
        <p class="text-sm font-semibold text-slate-700 dark:text-slate-300">No active keys found</p>
        <p class="text-xs text-slate-500 dark:text-slate-400 mt-1">Select an institution above to generate a new key.</p>
      </div>
      }
    </div>
  </div>
  } @else {
  <!-- Grid View -->
  <div>
    @if (isLoading()) {
    <div class="flex items-center justify-center py-16"><app-progress-loader></app-progress-loader></div>
    } @else if (hasApiKeys()) {
    <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
      @for (apiKey of apiKeys(); track apiKey.id) {
      <div class="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl p-5 hover:shadow-md transition-shadow">
        <div class="flex items-start justify-between mb-3">
          <div class="min-w-0">
            <p class="text-sm font-bold text-slate-900 dark:text-white truncate">{{ apiKey.institution.name || '—' }}</p>
            <span class="inline-block text-xs font-semibold text-slate-400 bg-slate-100 dark:bg-slate-900 px-1.5 py-0.5 rounded mt-0.5">{{ apiKey.institution.code || 'NO-CODE' }}</span>
          </div>
          <span class="ml-2 shrink-0 px-2 py-0.5 rounded-md text-[10px] font-bold border uppercase tracking-widest bg-emerald-50 dark:bg-emerald-950/40 text-emerald-600 dark:text-emerald-400 border-emerald-100 dark:border-emerald-900">Active</span>
        </div>
        <div class="mb-3">
          <p class="text-[10px] font-semibold text-slate-400 uppercase tracking-widest mb-0.5">Access</p>
          <div class="flex items-center gap-1.5">
            <span
              [title]="accessTooltip(apiKey)"
              [class]="apiKey.allowedOrigins?.length
                ? 'inline-block px-2 py-0.5 rounded-md text-[10px] font-semibold bg-amber-50 dark:bg-amber-950/40 text-amber-700 dark:text-amber-400 border border-amber-100 dark:border-amber-900'
                : 'inline-block px-2 py-0.5 rounded-md text-[10px] font-semibold bg-slate-100 dark:bg-slate-700/50 text-slate-500 dark:text-slate-400 border border-slate-200 dark:border-slate-700'">
              {{ accessSummary(apiKey) }}
            </span>
            @if (permissionService.canManage('apiKeys')) {
            <button (click)="openEditOrigins(apiKey)" class="p-1 text-slate-400 hover:text-primary-800 dark:text-primary-400 transition-colors shrink-0" title="Edit allowed origins">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z"/></svg>
            </button>
            }
          </div>
        </div>
        <div class="space-y-2 mb-4">
          <div>
            <p class="text-[10px] font-semibold text-slate-400 uppercase tracking-widest mb-0.5">Public Key</p>
            <div class="flex items-center gap-1.5">
              <code class="text-[10px] text-slate-500 dark:text-slate-400 font-mono bg-slate-50 dark:bg-slate-800/60 px-1.5 py-0.5 rounded border border-slate-100 dark:border-slate-700/50 truncate flex-1">{{ apiKey.publicKey }}</code>
              <button (click)="copyToClipboard(apiKey.publicKey, 'public')" class="p-1 text-slate-400 hover:text-primary-800 dark:text-primary-400 transition-colors shrink-0" title="Copy">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><rect width="14" height="14" x="8" y="8" rx="2" ry="2"/><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"/></svg>
              </button>
            </div>
          </div>
          <div>
            <p class="text-[10px] font-semibold text-slate-400 uppercase tracking-widest mb-0.5">Secret Key</p>
            <div class="flex items-center gap-1.5">
              <code class="text-[10px] text-slate-500 dark:text-slate-400 font-mono bg-slate-50 dark:bg-slate-800/60 px-1.5 py-0.5 rounded border border-slate-100 dark:border-slate-700/50 truncate flex-1">{{ isSecretRevealed(apiKey.id) ? apiKey.secretKey : maskSecret(apiKey.secretKey) }}</code>
              <button (click)="toggleSecretReveal(apiKey.id)" class="p-1 text-slate-400 hover:text-primary-800 dark:text-primary-400 transition-colors shrink-0" [title]="isSecretRevealed(apiKey.id) ? 'Hide secret key' : 'Show secret key'">
                <img [src]="isSecretRevealed(apiKey.id) ? _images.visible : _images.unvisible" alt="" class="w-3 h-3 opacity-60 hover:opacity-90 dark:invert transition-opacity">
              </button>
              <button (click)="copyToClipboard(apiKey.secretKey, 'secret')" class="p-1 text-slate-400 hover:text-primary-800 dark:text-primary-400 transition-colors shrink-0" title="Copy">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><rect width="14" height="14" x="8" y="8" rx="2" ry="2"/><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"/></svg>
              </button>
            </div>
          </div>
        </div>
        <div class="pt-3 border-t border-slate-100 dark:border-slate-700/50">
          <p class="text-[11px] text-slate-400">{{ apiKey.createdAt | date:'dd MMM yyyy' }}</p>
        </div>
      </div>
      }
    </div>
    } @else {
    <div class="flex flex-col items-center justify-center py-20 text-center">
      <p class="text-sm font-semibold text-slate-700 dark:text-slate-300">No active keys found</p>
    </div>
    }
  </div>
  }

  <!-- Pagination -->
  @if (hasApiKeys() && !isLoading()) {
  <app-pagination [totalItems]="totalItems()" [itemsPerPage]="perPage()" [currentPage]="currentPage()"
    (pageChange)="onPageChange($event)">
  </app-pagination>
  }
</main>

<!-- Modal -->
@if (isGenerateApiKeyModal()) {
<div
  class="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-slate-900/40 backdrop-blur-md animate-in fade-in duration-300">
  <div class="absolute inset-0" (click)="onCloseGenerateApiKeyModal()"></div>

  <div
    class="relative w-full max-w-md max-h-[90vh] flex flex-col bg-white dark:bg-slate-800 rounded-2xl shadow-[0_32px_64px_-12px_rgba(0,0,0,0.14),0_0_0_1px_rgba(0,0,0,0.02)] overflow-hidden animate-in zoom-in-95 slide-in-from-bottom-4 duration-300">
    <!-- Top Brand Glow -->
    <div class="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-primary/40 via-primary to-primary/40"></div>

    <div class="flex items-center justify-between px-10 py-7 border-b border-slate-100 dark:border-slate-700/50 bg-slate-50 dark:bg-slate-800/60 backdrop-blur-md">
      <div>
        <div class="flex items-center gap-2 mb-1">
          <div class="w-2 h-2 rounded-full bg-primary-800 animate-pulse"></div>
          <h3 class="text-xs font-bold text-slate-900 dark:text-white uppercase tracking-widest leading-none">Security Infrastructure
          </h3>
        </div>
        <p class="text-xxxs text-slate-500 dark:text-slate-400 font-bold uppercase tracking-wider">Generate Integration Credential</p>
      </div>
      <button (click)="onCloseGenerateApiKeyModal()"
        class="w-10 h-10 flex items-center justify-center text-slate-400 hover:text-slate-900 dark:text-white hover:bg-white dark:bg-slate-800 hover:shadow-lg rounded-full transition-all duration-300 group">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
          class="group-hover:rotate-90 transition-transform duration-300">
          <path d="M18 6 6 18" />
          <path d="m6 6 12 12" />
        </svg>
      </button>
    </div>

    <div class="p-10 overflow-y-auto">
      <app-generate-api-key (onCloseEvent)="onCloseGenerateApiKeyModal()" (onApiKeyGenerated)="onApiKeyGenerated()">
      </app-generate-api-key>
    </div>
  </div>
</div>
}

<!-- Edit Allowed Origins Modal -->
@if (isEditOriginsModal()) {
<div
  class="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-slate-900/40 backdrop-blur-md animate-in fade-in duration-300">
  <div class="absolute inset-0" (click)="closeEditOriginsModal()"></div>

  <div
    class="relative w-full max-w-md max-h-[90vh] flex flex-col bg-white dark:bg-slate-800 rounded-2xl shadow-[0_32px_64px_-12px_rgba(0,0,0,0.14),0_0_0_1px_rgba(0,0,0,0.02)] overflow-hidden animate-in zoom-in-95 slide-in-from-bottom-4 duration-300">
    <div class="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-primary/40 via-primary to-primary/40"></div>

    <div class="flex items-center justify-between px-10 py-7 border-b border-slate-100 dark:border-slate-700/50 bg-slate-50 dark:bg-slate-800/60 backdrop-blur-md">
      <div>
        <div class="flex items-center gap-2 mb-1">
          <div class="w-2 h-2 rounded-full bg-primary-800 animate-pulse"></div>
          <h3 class="text-xs font-bold text-slate-900 dark:text-white uppercase tracking-widest leading-none">Security Infrastructure</h3>
        </div>
        <p class="text-xxxs text-slate-500 dark:text-slate-400 font-bold uppercase tracking-wider">Update Allowed Origins</p>
      </div>
      <button (click)="closeEditOriginsModal()"
        class="w-10 h-10 flex items-center justify-center text-slate-400 hover:text-slate-900 dark:text-white hover:bg-white dark:bg-slate-800 hover:shadow-lg rounded-full transition-all duration-300 group">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
          class="group-hover:rotate-90 transition-transform duration-300">
          <path d="M18 6 6 18" />
          <path d="m6 6 12 12" />
        </svg>
      </button>
    </div>

    <div class="p-10 overflow-y-auto space-y-5">
      <div>
        <label for="editAllowedOrigins" class="block text-sm font-medium text-gray-700 dark:text-slate-300 mb-2">
          Allowed Origins
        </label>

        <!-- Chip list + draft input -->
        <div class="w-full px-2 py-2 bg-white dark:bg-slate-800 border rounded-lg flex flex-wrap items-center gap-1.5
            focus-within:ring-1 focus-within:ring-primary-500 dark:focus-within:ring-primary-400 focus-within:border-primary-500 dark:focus-within:border-primary-400 transition-colors"
          [class.border-rose-400]="editOriginsError"
          [class.border-gray-300]="!editOriginsError"
          [class.dark:border-slate-600]="!editOriginsError">
          @for (entry of editOriginEntries; track entry) {
          <span class="inline-flex items-center gap-1 pl-2 pr-1 py-0.5 rounded-md bg-slate-100 dark:bg-slate-700 border border-slate-200 dark:border-slate-600 text-[11px] font-mono text-slate-700 dark:text-slate-200 max-w-full">
            <span class="truncate">{{ entry }}</span>
            <button type="button" (click)="removeOriginEntry($index)" title="Remove"
              class="w-4 h-4 flex items-center justify-center rounded text-slate-400 hover:text-rose-500 hover:bg-rose-50 dark:hover:bg-rose-950/40 transition-colors flex-shrink-0">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </span>
          }
          <input id="editAllowedOrigins" type="text" [(ngModel)]="editOriginDraft"
            (keydown)="onOriginDraftKeydown($event)" (paste)="onOriginDraftPaste($event)"
            (blur)="commitOriginDraft()" (ngModelChange)="onOriginDraftChanged()"
            [placeholder]="editOriginEntries.length ? 'Add another…' : 'e.g. https://app.example.com'"
            class="flex-1 min-w-[140px] px-2 py-1 bg-transparent text-sm text-gray-900 dark:text-white focus:outline-none" />
        </div>

        @if (editOriginsError) {
        <p class="text-xs text-rose-500 mt-2">{{ editOriginsError }}</p>
        }

        <p class="text-gray-500 dark:text-slate-400 text-xs mt-2">Comma-separated origins, hosts, or IPs. Leave empty for no restriction.</p>
      </div>

      <div class="pt-4 space-y-3">
        <app-primary-button [text]="'Update Allowed Origins'" [isLoading]="isUpdatingOrigins"
          (onClickEvent)="submitEditOrigins()"></app-primary-button>
        @if (editOriginEntries.length > 0 || (editingApiKey()?.allowedOrigins?.length ?? 0) > 0) {
        <button type="button" (click)="requestClearRestrictions()" [disabled]="isUpdatingOrigins"
          class="w-full text-center text-xs font-semibold text-rose-600 dark:text-rose-400 hover:underline disabled:opacity-50">
          Remove all restrictions
        </button>
        }
      </div>
    </div>
  </div>
</div>
}

<!-- Clear restrictions confirmation (wrapper lifts the dialog's z-[70] overlay above the z-[100] edit modal) -->
@if (showClearRestrictionsConfirm) {
<div class="relative z-[110]">
<app-confirmation-dialog
  [title]="'Remove All Restrictions'"
  [message]="'This key will accept requests from any origin and any IP address. Are you sure?'"
  [confirmText]="'Remove restrictions'"
  [type]="'danger'"
  (onConfirm)="confirmClearRestrictions()"
  (onCancel)="cancelClearRestrictions()">
</app-confirmation-dialog>
</div>
}